;(function(){
(window.HK = window.HK || {}).hero = function (root, ctx) {
  ctx = ctx || {};
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, SplitType = ctx.SplitType;
  var reduce = !!ctx.reduce, fine = !!ctx.fine, mobile = !!ctx.mobile;
  function $(s) { return root.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

  /* ---- XP bar: fills with document scroll (gradient stop painted on the track) ---- */
  var xp = $('.hk-hero-xp');
  function setXP() {
    if (!xp) return;
    var doc = document.documentElement;
    var max = Math.max(1, doc.scrollHeight - window.innerHeight);
    var p = Math.min(100, Math.max(0, ((window.pageYOffset || doc.scrollTop || 0) / max) * 100));
    xp.style.setProperty('--hk-p', p.toFixed(2) + '%');
  }
  window.addEventListener('scroll', setXP, { passive: true });
  window.addEventListener('resize', setXP, { passive: true });
  setXP();

  /* Markup ships final states (72%, 3/4, meter 75%, spark drawn) — reduce/no-gsap keeps them. */
  if (reduce || !gsap) { root.classList.remove('hk-js'); return; }
  if (ST && gsap.registerPlugin) gsap.registerPlugin(ST);

  var counts = $$('.hk-hero-count');
  var meter = $('.hk-hero-meter');
  var spark = $('.hk-hero-spark-line');
  var dot = $('.hk-hero-spark-dot');
  var card = $('.hk-hero-card');
  var huds = $$('.hk-hero-hud');
  var shine = $('.hk-hero-shine');

  /* prime animated states */
  counts.forEach(function (el) { el.textContent = '0'; });
  if (meter) meter.style.setProperty('--hk-p', '0%');
  var sparkLen = 300;
  if (spark) {
    try { sparkLen = spark.getTotalLength(); } catch (e) {}
    spark.style.strokeDasharray = sparkLen;
    spark.style.strokeDashoffset = sparkLen;
  }
  if (dot) gsap.set(dot, { opacity: 0, scale: 0, transformOrigin: '50% 50%' });

  /* ---- H1: mask + skew line slam ---- */
  var h1 = $('.hk-hero-h1'), lines = null;
  if (SplitType) {
    try {
      var split = new SplitType(h1, { types: 'lines' });
      lines = (split.lines && split.lines.length) ? split.lines : null;
      if (lines) lines.forEach(function (ln) {
        var mask = document.createElement('span');
        mask.className = 'hk-hero-linemask';
        ln.parentNode.insertBefore(mask, ln);
        mask.appendChild(ln);
      });
    } catch (e) { lines = null; }
  }

  var chevs = $$('.hk-hero-chev');
  /* release the pre-paint gate in the same task the from() tweens set their
     hidden inline states — no paint happens in between, so no flash */
  root.classList.remove('hk-js');
  var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
  tl.from($('.hk-hero-nav'), { yPercent: -110, duration: 0.55 }, 0)
    .from(chevs, { x: -8, autoAlpha: 0, duration: 0.35, stagger: 0.09, ease: 'back.out(2.4)' }, 0.15)
    .to(chevs, { scale: 1.3, transformOrigin: '50% 50%', duration: 0.16, stagger: 0.07, yoyo: true, repeat: 1, ease: 'power2.inOut' }, 0.55)
    .from($('.hk-hero-eyebrow'), { y: 16, autoAlpha: 0, duration: 0.45 }, 0.22);
  if (lines) tl.from(lines, { yPercent: 115, skewY: 7, duration: 0.68, stagger: 0.09, ease: 'back.out(1.7)' }, 0.3);
  else tl.from(h1, { y: 44, autoAlpha: 0, duration: 0.68, ease: 'back.out(1.7)' }, 0.3);
  tl.from($('.hk-hero-sub'), { y: 22, autoAlpha: 0, duration: 0.5 }, '-=0.32')
    .from($$('.hk-hero-ctas .hk-hero-btn'), { y: 20, autoAlpha: 0, duration: 0.45, stagger: 0.08, ease: 'back.out(1.6)' }, '-=0.3')
    .from($('.hk-hero-hint'), { autoAlpha: 0, duration: 0.4 }, '-=0.2')
    .from(card, { y: 36, scale: 0.95, rotate: 2.2, autoAlpha: 0, duration: 0.7, ease: 'back.out(1.4)' }, 0.42)
    .from(huds, { y: 46, scale: 0.86, rotate: function (i) { return i ? 6 : -7; }, autoAlpha: 0, duration: 0.6, stagger: 0.12, ease: 'back.out(1.7)' }, 0.72)
    .add(runHUD, 0.98);
  if (shine) tl.fromTo(shine, { xPercent: -180, skewX: -18 }, { xPercent: 380, skewX: -18, duration: 0.8, ease: 'power2.inOut', clearProps: 'transform' }, 1.1);

  /* odometer counters (spring-settle), meter fill, sparkline draw */
  function runHUD() {
    counts.forEach(function (el) {
      var end = parseFloat(el.getAttribute('data-count')) || 0;
      var o = { v: 0 };
      gsap.to(o, {
        v: end, duration: 1.1, ease: 'back.out(1.6)',
        onUpdate: function () { el.textContent = Math.max(0, Math.round(o.v)); },
        onComplete: function () { el.textContent = end; }
      });
    });
    if (meter) {
      var m = { p: 0 };
      gsap.to(m, {
        p: 75, duration: 1, ease: 'back.out(1.3)',
        onUpdate: function () { meter.style.setProperty('--hk-p', Math.max(0, m.p) + '%'); }
      });
    }
    if (spark) gsap.to(spark, { strokeDashoffset: 0, duration: 1.05, ease: 'power2.inOut' });
    if (dot) gsap.to(dot, { opacity: 1, scale: 1, duration: 0.4, delay: 0.95, ease: 'back.out(2.5)' });
  }

  /* ---- ambient loops: mesh drift, ring spin, HUD float-bob, hint chevron ---- */
  $$('.hk-hero-blob').forEach(function (b, i) {
    gsap.to(b, { x: (i % 2 ? -1 : 1) * (26 + i * 9), y: (i % 2 ? 20 : -24) + i * 3, scale: 1.12, duration: 7 + i * 2.4, yoyo: true, repeat: -1, ease: 'sine.inOut' });
  });
  var ring = $('.hk-hero-ring');
  if (ring) gsap.to(ring, { rotation: 360, duration: 46, repeat: -1, ease: 'none' });
  if (huds[0]) gsap.to(huds[0], { y: '-=9', duration: 2.7, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 1.9 });
  if (huds[1]) gsap.to(huds[1], { y: '-=7', duration: 3.3, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 2.2 });
  var hintChev = $('.hk-hero-hint-chev');
  if (hintChev) gsap.to(hintChev, { y: 4, duration: 0.7, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 2 });

  /* ---- parallax depth on scroll (yPercent — never collides with bob's px y) ---- */
  if (ST && !mobile) {
    var par = gsap.timeline({ scrollTrigger: { trigger: root, start: 'top top', end: 'bottom top', scrub: 0.6 } });
    var copy = $('.hk-hero-copy'), bg = $('.hk-hero-bg');
    if (copy) par.to(copy, { yPercent: 12, ease: 'none' }, 0);
    if (bg) par.to(bg, { yPercent: 8, ease: 'none' }, 0);
    if (card) par.to(card, { yPercent: -7, ease: 'none' }, 0);
    if (huds[0]) par.to(huds[0], { yPercent: -30, ease: 'none' }, 0);
    if (huds[1]) par.to(huds[1], { yPercent: -16, ease: 'none' }, 0);
  }

  function tow(el, vars) { vars.overwrite = 'auto'; gsap.to(el, vars); }

  /* ---- magnetic CTAs (fine pointer) ---- */
  if (fine) {
    $$('[data-magnet]').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        tow(btn, { x: (e.clientX - r.left - r.width / 2) * 0.24, y: (e.clientY - r.top - r.height / 2) * 0.32, duration: 0.3, ease: 'power3.out' });
      });
      btn.addEventListener('mouseleave', function () {
        tow(btn, { x: 0, y: 0, duration: 0.55, ease: 'elastic.out(1,0.45)' });
      });
    });
  }

  /* ---- 3D tilt on the visual card (fine pointer) ---- */
  if (fine && card) {
    var stage = $('.hk-hero-stage');
    if (stage) {
      stage.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        tow(card, {
          rotationX: -((e.clientY - r.top) / r.height - 0.5) * 6,
          rotationY: ((e.clientX - r.left) / r.width - 0.5) * 7,
          transformPerspective: 900, duration: 0.5, ease: 'power2.out'
        });
      });
      stage.addEventListener('mouseleave', function () {
        tow(card, { rotationX: 0, rotationY: 0, duration: 0.7, ease: 'power3.out' });
      });
    }
  }

  /* ---- click ripple + recoil on every button ---- */
  $$('.hk-hero-btn').forEach(function (btn) {
    btn.addEventListener('pointerdown', function (e) {
      var r = btn.getBoundingClientRect();
      var rip = document.createElement('span');
      rip.className = 'hk-hero-ripple';
      rip.style.left = (e.clientX - r.left) + 'px';
      rip.style.top = (e.clientY - r.top) + 'px';
      btn.appendChild(rip);
      gsap.fromTo(rip, { scale: 0, opacity: 0.55 }, {
        scale: Math.max(r.width, r.height) / 9, opacity: 0, duration: 0.65, ease: 'power2.out',
        onComplete: function () { if (rip.parentNode) rip.parentNode.removeChild(rip); }
      });
      gsap.fromTo(btn, { scale: 0.95 }, { scale: 1, duration: 0.5, ease: 'elastic.out(1,0.5)' });
    });
  });
};
})();

;(function(){
(window.HK = window.HK || {}).trust = function (root, ctx) {
  const gsap = ctx.gsap, ScrollTrigger = ctx.ScrollTrigger, SplitType = ctx.SplitType;
  const reduce = ctx.reduce, fine = ctx.fine, mobile = ctx.mobile;
  if (!gsap) return;

  const rails = Array.prototype.slice.call(root.querySelectorAll('.hk-trust-rail'));
  const lede = root.querySelector('.hk-trust-lede');
  const micro = root.querySelector('.hk-trust-micro');
  const dot = root.querySelector('.hk-trust-dot');
  const divider = root.querySelector('.hk-trust-div');
  const spark = root.querySelector('.hk-trust-spark');
  const stack = root.querySelector('.hk-trust-avastack');
  const avas = Array.prototype.slice.call(root.querySelectorAll('.hk-trust-ava'));

  /* Reduced motion: final states only, no loops, no triggers */
  if (reduce) { root.classList.add('hk-trust-nofx'); return; }

  /* ---------- SIGNATURE: dual-direction seamless marquees ---------- */
  const marquees = [];
  function buildMarquee(rail) {
    const track = rail.querySelector('.hk-trust-track');
    const set = rail.querySelector('.hk-trust-set');
    const dir = rail.getAttribute('data-hk-dir') || 'rtl';
    const setW = set.offsetWidth;
    if (!setW) return null;
    const copies = Math.max(2, Math.ceil(rail.clientWidth / setW) + 1);
    for (let i = 1; i < copies; i++) {
      const c = set.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      track.appendChild(c);
    }
    const dur = setW / (dir === 'ltr' ? 44 : 38);
    const tween = dir === 'ltr'
      ? gsap.fromTo(track, { x: -setW }, { x: 0, duration: dur, ease: 'none', repeat: -1 })
      : gsap.fromTo(track, { x: 0 }, { x: -setW, duration: dur, ease: 'none', repeat: -1 });
    return { rail: rail, track: track, tween: tween, dir: dir, hover: false,
      skew: gsap.quickTo(track, 'skewX', { duration: .5, ease: 'power3.out' }) };
  }

  /* marquees run on ALL devices (owner: logos must revolve on mobile too);
     hover-pause stays pointer-only */
  rails.forEach(function (rail) {
    const mq = buildMarquee(rail);
    if (!mq) return;
    marquees.push(mq);
    if (fine) {
      rail.addEventListener('mouseenter', function () {
        mq.hover = true;
        gsap.to(mq.tween, { timeScale: 0, duration: .45, ease: 'power2.out', overwrite: true });
      });
      rail.addEventListener('mouseleave', function () {
        mq.hover = false;
        gsap.to(mq.tween, { timeScale: 1, duration: .6, ease: 'power2.out', overwrite: true });
      });
    }
  });

  {

    /* scroll-velocity boost + kinetic skew, springs back to cruise */
    const boost = { v: 0 };
    let sign = 1;
    const applyBoost = function () {
      marquees.forEach(function (mq) {
        if (!mq.hover) mq.tween.timeScale(1 + boost.v);
        mq.skew(sign * boost.v * 1.9 * (mq.dir === 'rtl' ? 1 : -1));
      });
    };
    ScrollTrigger.create({
      trigger: root, start: 'top bottom', end: 'bottom top',
      onUpdate: function (self) {
        const vel = self.getVelocity();
        sign = vel < 0 ? -1 : 1;
        boost.v = Math.max(boost.v, gsap.utils.clamp(0, 2.2, Math.abs(vel) / 900));
        applyBoost();
        gsap.to(boost, { v: 0, duration: 1.1, ease: 'power2.out', overwrite: true, onUpdate: applyBoost });
      },
      onToggle: function (self) {
        marquees.forEach(function (mq) { self.isActive ? mq.tween.play() : mq.tween.pause(); });
      }
    });
  }

  /* ---------- entrance: kinetic mask+skew reveals + spring deal-in ---------- */
  let lines = [lede];
  if (SplitType) {
    try {
      const sp = new SplitType(lede, { types: 'lines' });
      if (sp.lines && sp.lines.length) lines = sp.lines;
    } catch (e) { /* fall back to whole element */ }
  }
  lines.forEach(function (l) {
    const w = document.createElement('div');
    w.className = 'hk-trust-lmask';
    l.parentNode.insertBefore(w, l);
    w.appendChild(l);
  });

  const marksMentors = rails[0] ? Array.prototype.slice.call(rails[0].querySelectorAll('.hk-trust-mark')) : [];
  const marksPress = rails[1] ? Array.prototype.slice.call(rails[1].querySelectorAll('.hk-trust-pmark')) : [];

  gsap.set(lines, { yPercent: 115, skewY: 5 });
  gsap.set(avas, { scale: 0, y: 16, rotation: function (i) { return i === 1 ? 12 : -10; } });
  gsap.set(rails, { autoAlpha: 0 });
  const allMarks = marksMentors.concat(marksPress); if (allMarks.length) gsap.set(allMarks, { y: 22, autoAlpha: 0, rotation: function (i) { return i % 2 ? 4 : -4; } });
  if (divider) gsap.set(divider, { scaleX: 0, transformOrigin: '0 50%' });
  if (micro) gsap.set(micro, { autoAlpha: 0, y: 12, letterSpacing: '.34em' });

  const tl = gsap.timeline({ scrollTrigger: { trigger: root, start: 'top 80%', once: true } });
  tl.to(lines, { yPercent: 0, skewY: 0, duration: .7, ease: 'back.out(1.7)', stagger: .09 }, 0)
    .to(avas, { scale: 1, y: 0, rotation: 0, duration: .55, ease: 'back.out(1.7)', stagger: .07 }, .06)
    .to(rails, { autoAlpha: 1, duration: .45, ease: 'power1.out' }, .28)
    .to(marksMentors, { y: 0, autoAlpha: 1, rotation: 0, duration: .6, ease: 'back.out(1.7)', stagger: .045 }, .3)
    ;
  if (divider) tl.to(divider, { scaleX: 1, duration: .8, ease: 'power3.out' }, .5);
  if (micro) tl.to(micro, { autoAlpha: 1, y: 0, letterSpacing: '.22em', duration: .55, ease: 'power2.out' }, .58);
  if (marksPress.length) tl.to(marksPress, { y: 0, autoAlpha: 1, rotation: 0, duration: .6, ease: 'back.out(1.7)', stagger: .045 }, .62);
  tl.add(function () {
      /* fast launch settling into cruise speed */
      marquees.forEach(function (mq) {
        mq.tween.timeScale(2.6);
        gsap.to(mq.tween, { timeScale: 1, duration: 1.8, ease: 'power2.out' });
      });
      /* avatar shine sweep loop */
      if (stack) gsap.fromTo(stack, { '--hk-glx': '-150%' },
        { '--hk-glx': '250%', duration: 1.1, ease: 'power2.inOut' }); /* glass audit: one pass, no idle loop */
      /* micro-label live dot pulse */
      if (dot) gsap.fromTo(dot, { boxShadow: '0 0 0 0 rgba(12,154,95,.4)' },
        { boxShadow: '0 0 0 9px rgba(12,154,95,0)', duration: 1.6, repeat: -1, repeatDelay: .5, ease: 'power1.out' });
    }, .35);

  /* scroll-scrubbed spark traveling the divider hairline */
  if (spark && divider) {
    gsap.fromTo(spark, { x: 0 }, {
      x: function () { return Math.max(0, divider.clientWidth - 70); },
      ease: 'none',
      scrollTrigger: { trigger: root, start: 'top 95%', end: 'bottom 5%', scrub: 1, invalidateOnRefresh: true }
    });
  }

  /* fine-pointer 3D tilt on the avatar cluster */
  if (fine && stack) {
    gsap.set(stack, { transformPerspective: 500 });
    const rx = gsap.quickTo(stack, 'rotationX', { duration: .5, ease: 'power3.out' });
    const ry = gsap.quickTo(stack, 'rotationY', { duration: .5, ease: 'power3.out' });
    const lead = root.querySelector('.hk-trust-lead');
    lead.addEventListener('pointermove', function (e) {
      const b = lead.getBoundingClientRect();
      ry(((e.clientX - b.left) / b.width - .5) * 16);
      rx(((e.clientY - b.top) / b.height - .5) * -12);
    });
    lead.addEventListener('pointerleave', function () { rx(0); ry(0); });
  }

  /* rebuild marquees on meaningful resize (fonts/viewport width shifts) */
  if (!mobile) {
    let rw = window.innerWidth, rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (Math.abs(window.innerWidth - rw) < 60) return;
        rw = window.innerWidth;
        marquees.forEach(function (mq) {
          mq.tween.kill();
          mq.track.querySelectorAll('.hk-trust-set[aria-hidden]').forEach(function (s) { s.remove(); });
          gsap.set(mq.track, { x: 0, skewX: 0 });
          const nm = buildMarquee(mq.rail);
          if (nm) { mq.tween = nm.tween; mq.skew = nm.skew; }
        });
      }, 250);
    });
  }
};
})();

;(function(){
(window.HK = window.HK || {}).tracks = function (root, ctx) {
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, SplitType = ctx.SplitType;
  var reduce = !!ctx.reduce, fine = !!ctx.fine, mobile = !!ctx.mobile;
  var q = function (s) { return root.querySelector(s); };
  var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var viewport = q('.hk-tracks-viewport');
  var rail = q('.hk-tracks-rail');
  var cards = qa('.hk-tracks-card');
  var progress = q('.hk-tracks-progress');
  var countCur = q('.hk-tracks-count-cur');
  var n = cards.length;
  if (!viewport || !rail || !progress || !n) return;

  /* Progress fill: background-gradient stops painted ON the track element. */
  function paint(p) {
    p = Math.max(0, Math.min(100, p));
    progress.style.backgroundImage =
      'linear-gradient(90deg,var(--gb,#0c9a5f) 0%,var(--gb,#0c9a5f) ' + p + '%,var(--ln,#e2eae5) ' + p + '%)';
  }

  var active = -1;
  function setActive(i, anim) {
    if (i === active) return;
    active = i;
    for (var k = 0; k < n; k++) cards[k].classList.toggle('hk-tracks-card--on', k === i);
    var label = (i + 1 < 10 ? '0' : '') + (i + 1);
    if (!countCur) return;
    if (anim && !reduce && gsap) {
      gsap.to(countCur, { yPercent: -80, opacity: 0, duration: 0.14, ease: 'power2.in', overwrite: true, onComplete: function () {
        countCur.textContent = label;
        gsap.fromTo(countCur, { yPercent: 90, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.5, ease: 'back.out(2.4)' });
      } });
    } else {
      countCur.textContent = label;
    }
  }

  function centreActive(anim) {
    var vr = viewport.getBoundingClientRect();
    var cx = vr.left + vr.width / 2;
    var best = 0, bd = Infinity;
    for (var i = 0; i < n; i++) {
      var r = cards[i].getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - cx);
      if (d < bd) { bd = d; best = i; }
    }
    setActive(best, anim);
  }

  function enableSwipe() {
    root.classList.add('hk-tracks-sec--swipe');
    var tick = false;
    viewport.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var max = Math.max(1, viewport.scrollWidth - viewport.clientWidth);
        paint(viewport.scrollLeft / max * 100);
        centreActive(!reduce);
      });
    }, { passive: true });
  }

  paint(0);
  setActive(0, false);

  /* Reduced motion (or missing libs): final states, swipeable rail, no triggers, no loops. */
  if (reduce || !gsap || !ST) {
    enableSwipe();
    centreActive(false);
    return;
  }

  /* ---------- Entrance: kinetic mask+skew line reveal + spring deal-in ---------- */
  var title = q('.hk-tracks-title');
  var lineInners = null;
  if (SplitType && title) {
    try {
      var split = new SplitType(title, { types: 'lines' });
      (split.lines || []).forEach(function (line) {
        var inner = document.createElement('span');
        inner.className = 'hk-tracks-li';
        while (line.firstChild) inner.appendChild(line.firstChild);
        line.appendChild(inner);
      });
      lineInners = qa('.hk-tracks-li');
    } catch (e) { lineInners = null; }
  }

  var tl = gsap.timeline({
    defaults: { ease: 'back.out(1.7)' },
    scrollTrigger: { trigger: root, start: 'top 74%', once: true }
  });
  var eyebrow = q('.hk-tracks-eyebrow');
  if (eyebrow) tl.fromTo(eyebrow, { y: 16, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5 }, 0);
  if (lineInners && lineInners.length) {
    tl.fromTo(lineInners, { yPercent: 115, skewY: 6 }, { yPercent: 0, skewY: 0, duration: 0.65, stagger: 0.09 }, 0.05);
  } else if (title) {
    tl.fromTo(title, { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6 }, 0.05);
  }
  var counter = q('.hk-tracks-counter');
  if (counter) tl.fromTo(counter, { y: 14, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5 }, 0.28);
  tl.fromTo(cards,
    { y: 70, opacity: 0, scale: 0.92, rotation: function (i) { return i % 2 ? 3.5 : -3.5; } },
    { y: 0, opacity: 1, scale: 1, rotation: 0, duration: 0.6, ease: 'back.out(1.55)', stagger: 0.07, clearProps: 'transform,opacity' },
    0.22);
  var prow = q('.hk-tracks-progressrow');
  if (prow) tl.fromTo(prow, { opacity: 0 }, { opacity: 1, duration: 0.45, ease: 'power2.out' }, 0.55);
  var hint = q('.hk-tracks-hint');
  if (hint) tl.fromTo(hint, { opacity: 0 }, { opacity: 1, duration: 0.45, ease: 'power2.out' }, 0.6);

  /* ---------- Scroll-scrubbed accents ---------- */
  var ghost = q('.hk-tracks-ghost');
  if (ghost) gsap.to(ghost, { xPercent: -16, ease: 'none',
    scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 0.8 } });
  var orbA = q('.hk-tracks-orb--a');
  if (orbA) gsap.to(orbA, { y: -110, ease: 'none',
    scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 1 } });
  var orbB = q('.hk-tracks-orb--b');
  if (orbB) gsap.to(orbB, { y: 90, ease: 'none',
    scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 1 } });

  /* ---------- Micro-interactions: 3D tilt, shine sweep, ripple + recoil, magnetic chips ---------- */
  cards.forEach(function (card) {
    var inner = card.querySelector('.hk-tracks-card-in');
    var shine = card.querySelector('.hk-tracks-shine');
    if (!inner) return;

    if (fine) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        gsap.to(inner, { rotateY: px * 10, rotateX: -py * 8, transformPerspective: 900, duration: 0.45, ease: 'power2.out', overwrite: 'auto' });
      });
      card.addEventListener('mouseenter', function () {
        if (shine) gsap.fromTo(shine, { xPercent: -260, skewX: -18, opacity: 1 }, { xPercent: 340, skewX: -18, duration: 0.7, ease: 'power2.out', overwrite: true, onComplete: function(){ gsap.set(shine,{opacity:0}); } });
      });
      card.addEventListener('mouseleave', function () {
        gsap.to(inner, { rotateY: 0, rotateX: 0, duration: 0.7, ease: 'elastic.out(1,0.55)', overwrite: 'auto' });
      });
    }

    card.addEventListener('click', function (e) {
      var r = card.getBoundingClientRect();
      var rip = document.createElement('span');
      rip.className = 'hk-tracks-ripple';
      rip.style.left = ((e.clientX ? e.clientX - r.left : r.width / 2)) + 'px';
      rip.style.top = ((e.clientY ? e.clientY - r.top : r.height / 2)) + 'px';
      inner.appendChild(rip);
      gsap.fromTo(rip, { scale: 0, opacity: 0.55 }, { scale: 10, opacity: 0, duration: 0.7, ease: 'power2.out', onComplete: function () { rip.remove(); } });
      gsap.fromTo(inner, { scale: 0.965 }, { scale: 1, duration: 0.55, ease: 'back.out(2.6)', overwrite: 'auto' });
    });
  });

  if (fine) {
    qa('.hk-tracks-chip').forEach(function (chip) {
      chip.addEventListener('mousemove', function (e) {
        var r = chip.getBoundingClientRect();
        gsap.to(chip, { x: (e.clientX - (r.left + r.width / 2)) * 0.4, y: (e.clientY - (r.top + r.height / 2)) * 0.4, duration: 0.3, ease: 'power2.out', overwrite: 'auto' });
      });
      chip.addEventListener('mouseleave', function () {
        gsap.to(chip, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1,0.5)', overwrite: 'auto' });
      });
    });
  }

  /* ---------- Mobile: same pinned cross-axis scrub as desktop (owner call) ----------
     Previously fell back to native swipe; now vertical scroll drives the rail on
     touch too. Reduced-motion / no-GSAP still gets the swipe fallback above. */

  /* ---------- Signature: pinned cross-axis rail, scrubbed, snaps active at centre ---------- */
  function dist() { return Math.max(1, rail.scrollWidth - viewport.clientWidth); }
  function snapPoints() {
    var d = dist(), half = viewport.clientWidth / 2;
    return cards.map(function (c) {
      return Math.max(0, Math.min(1, (c.offsetLeft + c.offsetWidth / 2 - half) / d));
    });
  }

  var railTween = gsap.to(rail, {
    x: function () { return -dist(); },
    ease: 'none',
    scrollTrigger: {
      trigger: root,
      pin: root,
      start: 'top top',
      end: function () { return '+=' + Math.round(dist() + window.innerHeight * 0.4); },
      scrub: 0.55,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      snap: {
        snapTo: function (v) {
          return snapPoints().reduce(function (a, b) { return Math.abs(b - v) < Math.abs(a - v) ? b : a; }, 0);
        },
        duration: { min: 0.15, max: 0.45 },
        ease: 'power3.out',
        delay: 0.05
      },
      onUpdate: function (self) { paint(self.progress * 100); setActive(Math.min(n - 1, Math.max(0, Math.floor(self.progress * n))), true); },
      onRefresh: function (self) { paint(self.progress * 100); setActive(Math.min(n - 1, Math.max(0, Math.floor(self.progress * n))), false); }
    }
  });

  /* ---------- Auto-drift (owner): if the user idles while pinned, glide the
     scroll gently so the cards keep moving. Any input pauses it; "redo" = delete. ---------- */
  (function () {
    var st = railTween.scrollTrigger;
    if (!st || reduce) return;
    var lastInput = Date.now();
    function poke() { lastInput = Date.now(); }
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, poke, { passive: true });
    });
    gsap.ticker.add(function () {
      if (!st.isActive) return;
      if (Date.now() - lastInput < 2000) return;      /* user just interacted */
      if (st.progress >= 0.999) return;               /* rail finished */
      window.scrollBy(0, 1.54);  /* owner: +0.4x */                        /* ~66px/s — calm glide */
    });
  })();
};
})();

;(function(){
(window.HK = window.HK || {}).values = function (root, ctx) {
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger;
  var q = function (s) { return root.querySelector(s); };
  var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var cards   = qa('.hk-values-card');
  var tiles   = qa('.hk-values-iconwrap');
  var shines  = qa('.hk-values-shine');
  var strokes = qa('.hk-values-icon [data-draw]');
  var title   = q('.hk-values-title');
  var eyebrow = q('.hk-values-eyebrow');
  var sub     = q('.hk-values-sub');
  var rule    = q('.hk-values-rule');
  var mark    = q('.hk-values-mark');
  var orbA    = q('.hk-values-orb--a');
  var orbB    = q('.hk-values-orb--b');
  var grid    = q('.hk-values-grid');

  /* ---------- reduced motion: final states only, no triggers ---------- */
  if (ctx.reduce) {
    if (rule) rule.style.setProperty('--hk-values-p', 1);
    return;
  }

  /* ---------- header: kinetic mask + skew line reveal ---------- */
  var lines = null;
  if (ctx.SplitType && title) {
    try {
      var split = new ctx.SplitType(title, { types: 'lines' });
      if (split.lines && split.lines.length) {
        lines = split.lines;
        lines.forEach(function (ln) {
          var m = document.createElement('div');
          m.className = 'hk-values-lnmask';
          ln.parentNode.insertBefore(m, ln);
          m.appendChild(ln);
        });
        gsap.set(lines, { yPercent: 115, skewY: 6 });
      }
    } catch (e) { lines = null; }
  }
  if (!lines && title) gsap.set(title, { opacity: 0, y: 26 });
  if (eyebrow) gsap.set(eyebrow, { opacity: 0, y: 14 });
  if (sub) gsap.set(sub, { opacity: 0, y: 18 });

  ST.create({
    trigger: root, start: 'top 78%', once: true,
    onEnter: function () {
      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });
      if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' }, 0);
      if (lines) tl.to(lines, { yPercent: 0, skewY: 0, duration: 0.85, ease: 'back.out(1.7)', stagger: 0.09 }, 0.05);
      else if (title) tl.to(title, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' }, 0.05);
      if (sub) tl.to(sub, { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' }, 0.32);
    }
  });

  /* ---------- scrubbed rule fill: gradient stop painted on the track ---------- */
  if (rule) ST.create({
    trigger: root, start: 'top 82%', end: 'top 28%', scrub: true,
    onUpdate: function (self) { rule.style.setProperty('--hk-values-p', self.progress.toFixed(4)); }
  });

  /* ---------- SIGNATURE: deal-in spring stagger, alternating rotation ---------- */
  cards.forEach(function (c, i) {
    gsap.set(c, {
      y: 74, rotation: (i % 2 ? 5 : -5), scale: 0.92, opacity: 0,
      transformOrigin: '50% 100%', transformPerspective: 750
    });
  });
  gsap.set(tiles, { scale: 0, transformOrigin: '50% 50%' });
  strokes.forEach(function (p) {
    if (typeof p.getTotalLength !== 'function') return;
    var L; try { L = p.getTotalLength(); } catch (e) { return; }
    p.style.strokeDasharray = L;
    p.style.strokeDashoffset = L;
  });

  ST.create({
    trigger: grid || root, start: 'top 85%', once: true,
    onEnter: function () {
      var tl = gsap.timeline();
      tl.to(cards, { y: 0, rotation: 0, scale: 1, opacity: 1, duration: 0.62, ease: 'back.out(1.7)', stagger: 0.1 }, 0);
      tl.to(tiles, { scale: 1, duration: 0.9, ease: 'elastic.out(1, 0.55)', stagger: 0.1 }, 0.22);
      tl.to(strokes, { strokeDashoffset: 0, duration: 0.7, ease: 'power2.inOut', stagger: 0.045 }, 0.3);
      tl.fromTo(shines,
        { xPercent: -170, skewX: -18 },
        { xPercent: 300, skewX: -18, duration: 0.85, ease: 'power2.inOut', stagger: 0.1, clearProps: 'transform' }, 0.42);
    }
  });

  /* ---------- scroll-scrubbed accents ---------- */
  if (mark) gsap.to(mark, { rotation: 150, ease: 'none', scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 1 } });
  if (orbA) gsap.to(orbA, { y: -90, ease: 'none', scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 1.2 } });
  if (orbB) gsap.to(orbB, { y: 70, ease: 'none', scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 1.2 } });

  /* ---------- 3D tilt + magnetic icon tile (fine pointer only) ---------- */
  if (ctx.fine && !ctx.mobile) {
    cards.forEach(function (card) {
      var tile = card.querySelector('.hk-values-iconwrap');
      var rX = gsap.quickTo(card, 'rotationX', { duration: 0.45, ease: 'power3.out' });
      var rY = gsap.quickTo(card, 'rotationY', { duration: 0.45, ease: 'power3.out' });
      var tX = tile ? gsap.quickTo(tile, 'x', { duration: 0.4, ease: 'power3.out' }) : null;
      var tY = tile ? gsap.quickTo(tile, 'y', { duration: 0.4, ease: 'power3.out' }) : null;
      card.addEventListener('pointermove', function (e) {
        var b = card.getBoundingClientRect();
        var dx = (e.clientX - b.left) / b.width - 0.5;
        var dy = (e.clientY - b.top) / b.height - 0.5;
        rX(dy * -7); rY(dx * 9);
        if (tX) { tX(dx * 10); tY(dy * 8); }
      });
      card.addEventListener('pointerleave', function () {
        gsap.to(card, { rotationX: 0, rotationY: 0, duration: 0.6, ease: 'back.out(1.8)', overwrite: 'auto' });
        if (tile) gsap.to(tile, { x: 0, y: 0, duration: 0.55, ease: 'back.out(2)', overwrite: 'auto' });
      });
    });
  }

  /* ---------- click ripple + recoil ---------- */
  cards.forEach(function (card) {
    var inner = card.querySelector('.hk-values-cardin') || card;
    card.addEventListener('pointerdown', function (e) {
      var b = inner.getBoundingClientRect();
      var d = Math.max(b.width, b.height) * 2.1;
      var r = document.createElement('span');
      r.className = 'hk-values-ripple';
      r.style.width = r.style.height = d + 'px';
      r.style.left = (e.clientX - b.left - d / 2) + 'px';
      r.style.top = (e.clientY - b.top - d / 2) + 'px';
      inner.appendChild(r);
      gsap.fromTo(r, { scale: 0, opacity: 0.35 }, {
        scale: 1, opacity: 0, duration: 0.7, ease: 'power2.out',
        onComplete: function () { if (r.parentNode) r.parentNode.removeChild(r); }
      });
      gsap.timeline()
        .to(card, { scale: 0.965, duration: 0.09, ease: 'power2.out' })
        .to(card, { scale: 1, duration: 0.5, ease: 'back.out(3)' });
    });
  });
};
})();

;(function(){
(window.HK = window.HK || {}).mentors = function (root, ctx) {
  var gsap = ctx.gsap, ScrollTrigger = ctx.ScrollTrigger, Split = ctx.SplitType;
  var reduce = ctx.reduce, fine = ctx.fine, mobile = ctx.mobile;
  if (!gsap) return;
  if (ScrollTrigger && gsap.registerPlugin) gsap.registerPlugin(ScrollTrigger);

  function q(s) { return root.querySelector(s); }
  function qa(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

  var eyebrow = q('.hk-mentors-eyebrow'),
      title   = q('.hk-mentors-title'),
      body    = q('.hk-mentors-body'),
      cta     = q('.hk-mentors-cta'),
      arrow   = q('.hk-mentors-cta-arrow'),
      aurora  = q('.hk-mentors-aurora'),
      spot    = q('.hk-mentors-spot'),
      row     = q('.hk-mentors-row'),
      dotsBox = q('.hk-mentors-dots'),
      cards   = qa('.hk-mentors-card'),
      dots    = qa('.hk-mentors-dot'),
      sheens  = qa('.hk-mentors-sheen'),
      chips   = qa('.hk-mentors-chip');

  /* ---------- pagination dots (desktop: highlight, mobile: swipe-synced) ---------- */
  function isSwipe() { return window.matchMedia('(max-width: 820px)').matches; }
  function setDot(i) {
    dots.forEach(function (d, j) {
      d.classList.toggle('is-active', j === i);
      if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
  }
  function nearestCard() {
    var mid = row.scrollLeft + row.clientWidth / 2, best = 0, bd = 1e9;
    cards.forEach(function (c, i) {
      var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }
  var rafId = null;
  row.addEventListener('scroll', function () {
    if (!isSwipe() || rafId) return;
    rafId = requestAnimationFrame(function () { rafId = null; setDot(nearestCard()); });
  }, { passive: true });
  dots.forEach(function (d, i) {
    d.addEventListener('click', function () {
      if (isSwipe()) {
        var c = cards[i];
        row.scrollTo({ left: c.offsetLeft + c.offsetWidth / 2 - row.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
      } else {
        setDot(i);
        if (!reduce) gsap.fromTo(cards[i], { scale: 0.96 }, { scale: 1, duration: 0.5, ease: 'elastic.out(1, 0.5)', clearProps: 'scale' });
      }
    });
  });
  setDot(1);
  if (isSwipe() && cards[1]) {
    row.scrollLeft = cards[1].offsetLeft + cards[1].offsetWidth / 2 - row.clientWidth / 2;
  }

  if (reduce) return; /* CSS defaults are the final states; no triggers, no loops */

  /* ---------- initial states ---------- */
  gsap.set(eyebrow, { autoAlpha: 0, x: -18 });
  gsap.set(body, { autoAlpha: 0, y: 22 });
  gsap.set(cta, { autoAlpha: 0, y: 22 });
  if (dotsBox) gsap.set(dotsBox, { autoAlpha: 0, y: 12 });
  gsap.set(aurora, { autoAlpha: 0, scale: 0.8 });
  cards.forEach(function (c, i) {
    gsap.set(c, { autoAlpha: 0, y: 70, rotation: (i - 1) * 6, scale: 0.94, transformPerspective: 900 });
  });
  gsap.set(chips, { autoAlpha: 0, scale: 0.6 });

  /* kinetic mask+skew line reveal on the H2 */
  var split = null, lineIns = [];
  if (Split && title) {
    split = new Split(title, { types: 'lines' });
    (split.lines || []).forEach(function (line) {
      var inner = document.createElement('span');
      inner.className = 'hk-mentors-line-in';
      while (line.firstChild) inner.appendChild(line.firstChild);
      line.appendChild(inner);
      line.classList.add('hk-mentors-line');
      lineIns.push(inner);
    });
  }
  if (lineIns.length) gsap.set(lineIns, { yPercent: 115, skewY: 5 });
  else gsap.set(title, { autoAlpha: 0, y: 26 });

  /* ---------- entrance timeline ---------- */
  var tl = gsap.timeline({
    defaults: { ease: 'back.out(1.7)' },
    scrollTrigger: ScrollTrigger ? { trigger: root, start: 'top 72%', once: true } : null,
    onComplete: function () { if (split && split.revert) split.revert(); }
  });
  tl.to(aurora, { autoAlpha: 0.85, scale: 1, duration: 1.1, ease: 'power2.out' }, 0)
    .to(eyebrow, { autoAlpha: 1, x: 0, duration: 0.5, ease: 'power3.out' }, 0.05);
  if (lineIns.length) tl.to(lineIns, { yPercent: 0, skewY: 0, duration: 0.7, stagger: 0.09 }, 0.12);
  else tl.to(title, { autoAlpha: 1, y: 0, duration: 0.6 }, 0.12);
  tl.to(body, { autoAlpha: 1, y: 0, duration: 0.55, ease: 'power3.out' }, 0.42)
    .to(cta, { autoAlpha: 1, y: 0, duration: 0.55 }, 0.52)
    .to(cards, { autoAlpha: 1, y: 0, rotation: 0, scale: 1, duration: 0.65, stagger: { each: 0.11, from: mobile ? 0 : 'center' } }, 0.35)
    .to(chips, { autoAlpha: 1, scale: 1, duration: 0.45, ease: 'back.out(2)', stagger: 0.08 }, 0.72)
    .fromTo(sheens, { xPercent: -160, skewX: -18 }, { xPercent: 320, skewX: -18, duration: 0.9, ease: 'power2.inOut', stagger: 0.11 }, 0.78);
  if (dotsBox) tl.to(dotsBox, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out' }, 0.95);

  /* ---------- SIGNATURE: revolving conic aurora + scroll drift ---------- */
  gsap.to(aurora, { rotation: 360, duration: 46, ease: 'none', repeat: -1 });
  if (ScrollTrigger) {
    gsap.fromTo(aurora, { yPercent: 8 }, {
      yPercent: -8, ease: 'none',
      scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  }

  /* ---------- SIGNATURE: cursor spotlight on the band (fine pointer) ---------- */
  if (fine && spot) {
    var tx = 0.5, ty = 0.4, cx = 0.5, cy = 0.4, lit = false;
    root.addEventListener('pointermove', function (e) {
      var r = root.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width;
      ty = (e.clientY - r.top) / r.height;
      if (!lit) { lit = true; gsap.to(spot, { autoAlpha: 1, duration: 0.6, ease: 'power2.out' }); }
    });
    root.addEventListener('pointerleave', function () {
      lit = false;
      gsap.to(spot, { autoAlpha: 0, duration: 0.8, ease: 'power2.out' });
    });
    gsap.ticker.add(function () {
      cx += (tx - cx) * 0.12;
      cy += (ty - cy) * 0.12;
      spot.style.setProperty('--hk-mx', (cx * 100).toFixed(2) + '%');
      spot.style.setProperty('--hk-my', (cy * 100).toFixed(2) + '%');
    });
  }

  /* ---------- card hover: lift + 3D tilt + sheen (fine pointer) ---------- */
  if (fine) {
    cards.forEach(function (card) {
      var sheen = card.querySelector('.hk-mentors-sheen');
      var rx = gsap.quickTo(card, 'rotationX', { duration: 0.45, ease: 'power2.out' });
      var ry = gsap.quickTo(card, 'rotationY', { duration: 0.45, ease: 'power2.out' });
      card.addEventListener('pointerenter', function () {
        card.style.zIndex = 3;
        gsap.to(card, { y: -12, scale: 1.02, duration: 0.45, ease: 'power3.out' });
        gsap.fromTo(sheen, { xPercent: -160, skewX: -18 }, { xPercent: 320, skewX: -18, duration: 0.8, ease: 'power2.inOut' });
      });
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        ry(((e.clientX - r.left) / r.width - 0.5) * 10);
        rx(((e.clientY - r.top) / r.height - 0.5) * -10);
      });
      card.addEventListener('pointerleave', function () {
        rx(0); ry(0);
        gsap.to(card, { y: 0, scale: 1, duration: 0.55, ease: 'power3.out', onComplete: function () { card.style.zIndex = ''; } });
      });
    });
  }

  /* ---------- magnetic CTA (fine pointer) ---------- */
  if (fine && cta) {
    var mx = gsap.quickTo(cta, 'x', { duration: 0.4, ease: 'power3.out' });
    var my = gsap.quickTo(cta, 'y', { duration: 0.4, ease: 'power3.out' });
    cta.addEventListener('pointermove', function (e) {
      var r = cta.getBoundingClientRect();
      mx((e.clientX - (r.left + r.width / 2)) * 0.32);
      my((e.clientY - (r.top + r.height / 2)) * 0.32);
    });
    cta.addEventListener('pointerleave', function () {
      gsap.to(cta, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.45)' });
    });
  }

  /* ---------- CTA click ripple + recoil ---------- */
  if (cta) {
    cta.addEventListener('click', function (e) {
      var r = cta.getBoundingClientRect();
      var s = document.createElement('span');
      s.className = 'hk-mentors-ripple';
      var size = Math.max(r.width, r.height) * 2.2;
      s.style.width = s.style.height = size + 'px';
      s.style.left = (e.clientX ? e.clientX - r.left : r.width / 2) + 'px';
      s.style.top = (e.clientY ? e.clientY - r.top : r.height / 2) + 'px';
      cta.appendChild(s);
      gsap.fromTo(s, { scale: 0, opacity: 0.5 }, { scale: 1, opacity: 0, duration: 0.6, ease: 'power2.out', onComplete: function () { s.remove(); } });
      gsap.fromTo(cta, { scale: 0.94 }, { scale: 1, duration: 0.55, ease: 'elastic.out(1, 0.5)' });
      if (arrow) gsap.fromTo(arrow, { x: 0 }, { x: 6, yoyo: true, repeat: 1, duration: 0.18, ease: 'power2.inOut' });
    });
  }
};
})();

;(function(){
(window.HK = window.HK || {}).proof = function (root, ctx) {
  if (root._hkProofInit) return; root._hkProofInit = true;
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, reduce = ctx.reduce, fine = ctx.fine;
  if (!gsap) return;
  if (ST && gsap.registerPlugin) gsap.registerPlugin(ST);

  var q = function (s) { return root.querySelector(s); };
  var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var copy = q('.hk-proof-copy'), h2 = q('.hk-proof-h2'), eyebrow = q('.hk-proof-eyebrow'),
      body = q('.hk-proof-body'), linkWrap = q('.hk-proof-link-wrap'), link = q('.hk-proof-link'),
      cardWrap = q('.hk-proof-card-wrap'), card = q('.hk-proof-card'), qmark = q('.hk-proof-qmark'),
      quote = q('.hk-proof-quote'), who = q('.hk-proof-who'), shine = q('.hk-proof-shine'),
      stats = q('.hk-proof-stats'), tiles = qa('.hk-proof-tile'),
      mark = q('.hk-proof-mark'), blob = q('.hk-proof-blob');

  var INK = '#0c1411', BRIGHT = '#0c9a5f';

  // Gauge prep: reduce -> paint final arc, no motion anywhere else (defaults are final states)
  tiles.forEach(function (tile) {
    var fill = tile.querySelector('.hk-proof-g-fill');
    var pct = Math.max(0, Math.min(100, parseFloat(tile.getAttribute('data-gauge')) || 0));
    tile._pf = fill; tile._pct = pct;
    fill.style.strokeDasharray = '100';
    fill.style.strokeDashoffset = reduce ? String(100 - pct) : '100';
  });
  if (reduce) return;

  function tlFor(trigger, start) {
    return ST ? gsap.timeline({ scrollTrigger: { trigger: trigger, start: start, once: true } }) : gsap.timeline();
  }

  // ---- Copy column: kinetic mask+skew line reveal
  var tl = tlFor(copy, 'top 80%');
  tl.fromTo(eyebrow, { y: 16, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, ease: 'power3.out' }, 0);
  if (ctx.SplitType) {
    var split = new ctx.SplitType(h2, { types: 'lines' });
    (split.lines || []).forEach(function (ln) {
      var w = document.createElement('div'); w.className = 'hk-proof-linewrap';
      ln.parentNode.insertBefore(w, ln); w.appendChild(ln);
    });
    tl.fromTo(split.lines, { yPercent: 115, skewY: 5 }, { yPercent: 0, skewY: 0, duration: 0.7, ease: 'back.out(1.7)', stagger: 0.09 }, 0.05);
  } else {
    tl.fromTo(h2, { y: 44, opacity: 0 }, { y: 0, opacity: 1, duration: 0.65, ease: 'back.out(1.5)' }, 0.05);
  }
  tl.fromTo(body, { y: 26, opacity: 0 }, { y: 0, opacity: 1, duration: 0.55, ease: 'power3.out' }, 0.32);
  tl.fromTo(linkWrap, { y: 22, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, ease: 'back.out(1.6)' }, 0.44);

  // ---- Quote card: float up, qmark overshoot drop, shine sweep, idle float
  var ctl = tlFor(cardWrap, 'top 80%');
  ctl.eventCallback('onComplete', function () {
    gsap.to(card, { y: -9, duration: 2.8, ease: 'sine.inOut', yoyo: true, repeat: -1 });
  });
  ctl.fromTo(card, { y: 70, opacity: 0, rotate: 1.6 }, { y: 0, opacity: 1, rotate: 0, duration: 0.7, ease: 'back.out(1.4)' }, 0);
  ctl.fromTo(qmark, { y: -74, opacity: 0, scale: 0.4, rotate: -10 }, { y: 0, opacity: 1, scale: 1, rotate: 0, duration: 0.65, ease: 'back.out(2.2)' }, 0.18);
  ctl.fromTo(quote, { y: 22, opacity: 0 }, { y: 0, opacity: 1, duration: 0.55, ease: 'power3.out' }, 0.3);
  ctl.fromTo(who, { y: 18, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, ease: 'back.out(1.6)' }, 0.42);
  ctl.fromTo(shine, { xPercent: 0 }, { xPercent: 600, duration: 0.9, ease: 'power2.inOut' }, 0.35);

  // 3D tilt (fine pointers)
  if (fine) {
    cardWrap.addEventListener('pointermove', function (e) {
      var b = cardWrap.getBoundingClientRect();
      var dx = (e.clientX - b.left) / b.width - 0.5;
      var dy = (e.clientY - b.top) / b.height - 0.5;
      gsap.to(card, { rotationY: dx * 7, rotationX: -dy * 7, transformPerspective: 900, duration: 0.5, ease: 'power2.out' });
    });
    cardWrap.addEventListener('pointerleave', function () {
      gsap.to(card, { rotationY: 0, rotationX: 0, duration: 0.7, ease: 'power3.out' });
    });
  }

  // ---- Gamerscore stats: deal-in, gauge draw, odometer slam
  function buildOdo(val) {
    var txt = val.getAttribute('data-odo') || val.textContent;
    val.setAttribute('aria-label', txt);
    val.textContent = '';
    var row = document.createElement('span');
    row.className = 'hk-proof-odo-row';
    row.setAttribute('aria-hidden', 'true');
    var reels = [];
    for (var i = 0; i < txt.length; i++) {
      var ch = txt.charAt(i);
      if (/\d/.test(ch)) {
        var win = document.createElement('span'); win.className = 'hk-proof-odo';
        var reel = document.createElement('span'); reel.className = 'hk-proof-odo-reel';
        var html = '';
        for (var c = 0; c < 2; c++) for (var d = 0; d <= 9; d++) html += '<span class="hk-proof-odo-d">' + d + '</span>';
        reel.innerHTML = html;
        reel._odo = 10 + parseInt(ch, 10); // second cycle -> full extra spin
        win.appendChild(reel); row.appendChild(win); reels.push(reel);
      } else {
        var s = document.createElement('span'); s.className = 'hk-proof-odo-ch'; s.textContent = ch; row.appendChild(s);
      }
    }
    val.appendChild(row);
    return reels;
  }

  var stl = tlFor(stats, 'top 85%');
  tiles.forEach(function (tile, i) {
    var val = tile.querySelector('.hk-proof-val');
    var ping = tile.querySelector('.hk-proof-ping');
    var reels = buildOdo(val);
    var at = i * 0.12;
    stl.fromTo(tile, { y: 64, opacity: 0, rotate: i % 2 ? 3.5 : -3.5 },
      { y: 0, opacity: 1, rotate: 0, duration: 0.6, ease: 'back.out(1.6)' }, at);
    stl.to(tile._pf, { strokeDashoffset: 100 - tile._pct, duration: 0.9, ease: 'power2.out' }, at + 0.28);
    if (reels.length) {
      stl.to(reels, {
        yPercent: function (idx, t) { return -(t._odo * 5); }, // 20 digits -> 5% each
        duration: 0.85, ease: 'back.out(1.4)', stagger: 0.07,
        onComplete: function () { // slam: scale flash + color pop + ring ping
          gsap.fromTo(val, { scale: 1.16 }, { scale: 1, duration: 0.5, ease: 'back.out(2.5)' });
          gsap.fromTo(val, { color: BRIGHT }, { color: INK, duration: 0.7, ease: 'power2.out' });
          gsap.fromTo(ping, { opacity: 0.7, scale: 0.94 }, { opacity: 0, scale: 1.1, duration: 0.6, ease: 'power2.out' });
        }
      }, at + 0.22);
    }
  });

  // ---- Click ripple + recoil
  function pressFX(el) {
    el.addEventListener('pointerdown', function (e) {
      var b = el.getBoundingClientRect();
      var r = document.createElement('span'); r.className = 'hk-proof-ripple';
      r.style.left = (e.clientX - b.left) + 'px'; r.style.top = (e.clientY - b.top) + 'px';
      el.appendChild(r);
      gsap.fromTo(r, { scale: 0, opacity: 0.4 }, { scale: 24, opacity: 0, duration: 0.65, ease: 'power2.out',
        onComplete: function () { if (r.parentNode) r.parentNode.removeChild(r); } });
      gsap.fromTo(el, { scale: 0.965 }, { scale: 1, duration: 0.5, ease: 'back.out(3)' });
    });
  }
  tiles.forEach(pressFX); pressFX(link);

  // ---- Magnetic CTA (fine pointers, listens on static wrapper)
  if (fine) {
    linkWrap.addEventListener('mousemove', function (e) {
      var b = linkWrap.getBoundingClientRect();
      gsap.to(link, { x: (e.clientX - b.left - b.width / 2) * 0.28, y: (e.clientY - b.top - b.height / 2) * 0.42, duration: 0.4, ease: 'power3.out' });
    });
    linkWrap.addEventListener('mouseleave', function () {
      gsap.to(link, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1,0.45)' });
    });
  }

  // ---- Scroll-scrubbed accents
  if (ST) {
    gsap.fromTo(mark, { xPercent: 5 }, { xPercent: -5, ease: 'none',
      scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: true } });
    gsap.fromTo(blob, { yPercent: -12 }, { yPercent: 14, ease: 'none',
      scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: true } });
  }
};
})();

;(function(){
(window.HK=window.HK||{}).final=function(root,ctx){
var g=ctx.gsap,reduce=ctx.reduce,fine=ctx.fine;
if(reduce||!g)return;
var rises=root.querySelectorAll('[data-fx-rise]');
g.set(rises,{y:26,opacity:0});
g.to(rises,{y:0,opacity:1,duration:.55,ease:'back.out(1.7)',stagger:.08,scrollTrigger:{trigger:root,start:'top 80%'},onComplete:function(){g.set(rises,{clearProps:'transform'});}});
var h=root.querySelector('[data-fx-kh]');
if(h&&ctx.SplitType){try{var t=new ctx.SplitType(h,{types:'lines'});
t.lines.forEach(function(l){var w=document.createElement('span');w.style.cssText='display:block;overflow:hidden';l.parentNode.insertBefore(w,l);w.appendChild(l);});
g.set(t.lines,{yPercent:115,skewY:5});
g.to(t.lines,{yPercent:0,skewY:0,duration:.66,ease:'back.out(1.7)',stagger:.09,scrollTrigger:{trigger:h,start:'top 85%'}});}catch(e){}}
if(fine)root.querySelectorAll('[data-fx-mag]').forEach(function(el){
el.addEventListener('pointermove',function(e){var r=el.getBoundingClientRect();g.to(el,{x:(e.clientX-r.left-r.width/2)*.28,y:(e.clientY-r.top-r.height/2)*.32,duration:.4,ease:'power4.out'});});
el.addEventListener('pointerleave',function(){g.to(el,{x:0,y:0,duration:.6,ease:'elastic.out(1,.55)'});});});
var canvas=root.querySelector('[data-burst]');
if(canvas){var cx=canvas.getContext('2d'),parts=[],raf=null;
function size(){var r=canvas.parentElement.getBoundingClientRect();canvas.width=r.width;canvas.height=r.height;}
size();window.addEventListener('resize',size);
function burst(){var cw=canvas.width/2,ch=canvas.height/2;for(var i=0;i<60;i++){var a=Math.PI*2*i/60,sp=2+((i*11)%35)/10;parts.push({x:cw,y:ch,vx:Math.cos(a)*sp,vy:Math.sin(a)*sp-1.6,life:1,c:i%2?'#0c9a5f':'#b7e2c7'});}if(!raf)loop();}
function loop(){cx.clearRect(0,0,canvas.width,canvas.height);var on=false;
parts.forEach(function(p){if(p.life<=0)return;on=true;p.x+=p.vx;p.y+=p.vy;p.vy+=.07;p.life-=.015;cx.globalAlpha=Math.max(0,p.life);cx.fillStyle=p.c;cx.beginPath();cx.arc(p.x,p.y,2.6,0,7);cx.fill();});
cx.globalAlpha=1;if(on){raf=requestAnimationFrame(loop);}else{raf=null;parts=[];}}
root.querySelectorAll('.hk-final-cta--go').forEach(function(b){b.addEventListener('click',function(ev){burst();});});
if(ctx.ScrollTrigger)ctx.ScrollTrigger.create({trigger:root,start:'top 60%',once:true,onEnter:burst});}
};
})();
;(function(){
(window.BG = window.BG || {}).halftone = function (root) {
  var canvas = root.querySelector('.bg-halftone__canvas');
  if (!canvas || canvas.__bgHalftone) return;
  canvas.__bgHalftone = true;

  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var W = 0, H = 0, dots = [], raf = 0, running = false;

  var GAP = 20;          // grid spacing (px)
  var BASE = 0.8;        // resting dot radius
  var AMP = 1.5;         // pulse amplitude
  var LEVELS = 14;       // quantized ramp -> few fillStyle switches
  var TAU = Math.PI * 2;

  // Brand-only ramp, hard-capped at 0.35 alpha:
  // pale mint -> mint -> deep brand green (bright mid-stop removed)
  var stops = [
    [232, 245, 238, 0.00],
    [183, 226, 199, 0.18],
    [0, 112, 73, 0.35]
  ];
  var styles = [];
  for (var i = 0; i < LEVELS; i++) {
    var t = i / (LEVELS - 1);
    var seg = Math.min(1, Math.floor(t * 2));
    var f = t * 2 - seg;
    var a = stops[seg], b = stops[seg + 1];
    styles.push('rgba(' +
      Math.round(a[0] + (b[0] - a[0]) * f) + ',' +
      Math.round(a[1] + (b[1] - a[1]) * f) + ',' +
      Math.round(a[2] + (b[2] - a[2]) * f) + ',' +
      (a[3] + (b[3] - a[3]) * f).toFixed(3) + ')');
  }

  function build() {
    var rect = root.getBoundingClientRect();
    var w = Math.max(1, Math.round(rect.width));
    var h = Math.max(1, Math.round(rect.height));
    if (w === W && h === H && dots.length) return false;
    W = w; H = h;
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    dots = [];
    var cx = W * 0.5, cy = H * 0.42;
    // Copy column: superellipse keep-out zone under the headline/subcopy.
    // Dots inside are never created (true zero alpha), with a short soft
    // shoulder just outside so the boundary doesn't read as a box.
    var colRX = Math.min(W * 0.36, 460);
    var colRY = H * 0.38;
    var SHOULDER = 0.35;
    for (var y = GAP * 0.5; y < H; y += GAP) {
      for (var x = GAP * 0.5; x < W; x += GAP) {
        var ex = Math.abs(x - cx) / colRX;
        var ey = Math.abs(y - cy) / colRY;
        var sd = Math.pow(Math.pow(ex, 4) + Math.pow(ey, 4), 0.25);
        if (sd <= 1) continue;                    // hard zero in copy column
        var s = (sd - 1) / SHOULDER;
        var col = s >= 1 ? 1 : s * s * (3 - 2 * s);
        var dx = (x - cx) / (W * 0.5);
        var dy = (y - cy) / (H * 0.55);
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d > 1) d = 1;
        var fade = col * (0.5 + 0.5 * d);         // richer toward hero edges
        if (fade < 0.06) continue;
        dots.push(x, y, fade, (Math.random() - 0.5) * 0.12);
      }
    }
    return true;
  }

  function draw(time) {
    ctx.clearRect(0, 0, W, H);
    var t1 = time * 0.45;
    var t2 = time * 0.30 + 1.7;
    var paths = new Array(LEVELS);
    for (var i = 0; i < dots.length; i += 4) {
      var x = dots[i], y = dots[i + 1], fade = dots[i + 2];
      // two slow travelling plane waves -> drifting interference (signal read)
      var v = Math.sin(x * 0.011 + y * 0.0063 - t1) * 0.62 +
              Math.sin(y * 0.0104 - x * 0.0068 - t2) * 0.38;
      var n = (v + 1) * 0.5 + dots[i + 3];
      if (n <= 0.05) continue;
      if (n > 1) n = 1;
      var lvl = Math.round(n * fade * (LEVELS - 1));
      if (!lvl) continue;
      var r = (BASE + Math.pow(n, 1.5) * AMP) * (0.8 + 0.2 * fade);
      var p = paths[lvl] || (paths[lvl] = new Path2D());
      p.moveTo(x + r, y);
      p.arc(x, y, r, 0, TAU);
    }
    for (var l = 1; l < LEVELS; l++) {
      if (!paths[l]) continue;
      ctx.fillStyle = styles[l];
      ctx.fill(paths[l]);
    }
  }

  function frame(now) {
    draw(now / 1000);
    raf = requestAnimationFrame(frame);
  }
  function start() {
    if (running) return;
    running = true;
    raf = requestAnimationFrame(frame);
  }
  function stop() {
    running = false;
    cancelAnimationFrame(raf);
  }
  function update() {
    if (mq.matches) { stop(); draw(3.2); }        // calm static frame
    else if (document.hidden) { stop(); }
    else { start(); }
  }

  if ('ResizeObserver' in window) {
    new ResizeObserver(function () {
      if (build() && mq.matches) draw(3.2);
    }).observe(root);
  } else {
    window.addEventListener('resize', function () {
      if (build() && mq.matches) draw(3.2);
    });
  }

  document.addEventListener('visibilitychange', update);
  if (mq.addEventListener) mq.addEventListener('change', update);
  else if (mq.addListener) mq.addListener(update);

  build();
  update();
};
})();

;(function(){/* BG.halftone init */
  function go(){var el=document.querySelector('.hk-hero-bg .bg-halftone');var fn=window.BG&&window.BG.halftone;
    if(el&&fn){try{fn(el);}catch(e){console.error('halftone',e);}}}
  if(document.readyState!=='loading') go(); else document.addEventListener('DOMContentLoaded',go);
})();

;(function(){/* settle odometers to plain text after slam (kills digit-slot gaps) */
  function settle(){
    document.querySelectorAll('.hk-proof-val').forEach(function(v){
      var t=v.getAttribute('aria-label')||v.getAttribute('data-odo');
      if(t) v.textContent=t;
    });
  }
  if('IntersectionObserver' in window){
    var done=false;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting&&!done){ done=true; setTimeout(settle,3000); io.disconnect(); } });
    },{threshold:.3});
    var el=document.querySelector('.hk-proof-val');
    if(el) io.observe(el);
  } else { setTimeout(settle,6000); }
})();
